/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import IDivisionesTiposPropiedades from 'Infotrack@Modelos/smartStock/divisionesTiposPropiedades/entidades/divisionesTiposPropiedades';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import { AnyAction } from 'redux';

export interface IEstadoDivisionesTiposPropiedades {
    estadoFormulario: boolean;
    entidadDivisionesTiposPropiedades: IDivisionesTiposPropiedades | null;
    recargarTabla: boolean;
    tipoFormulario: TipoFormulario;
}

export const estadoIncial: IEstadoDivisionesTiposPropiedades = {
    entidadDivisionesTiposPropiedades: null,
    estadoFormulario: false,
    recargarTabla: false,
    tipoFormulario: TipoFormulario.Creacion,
};

export enum acciones {
    CAMBIAR_ESTADO_FORMULARIO = 'CAMBIAR_ESTADO_FORMULARIO',
    RECARGAR_TABLA = 'RECARGAR_TABLA',
}

export const reductor = (estado: IEstadoDivisionesTiposPropiedades, { type, payload }: AnyAction) => {
    switch (type) {
        case 'CAMBIAR_ESTADO_FORMULARIO': {
            return {
                ...estado,
                entidadDivisionesTiposPropiedades: payload ? payload.entidadDivisionesTiposPropiedades : null,
                estadoFormulario: !estado.estadoFormulario,
                tipoFormulario: payload ? payload.tipoFormulario : estado.tipoFormulario,
            };
        }
        case 'RECARGAR_TABLA':
            return {
                ...estado,
                recargarTabla: !estado.recargarTabla,
            };

        default:
            return estado;
    }
};
